import type { HTMLProps } from 'react';
import React from 'react';

type Axis = 'vertical' | 'horizontal';

interface IProps extends HTMLProps<HTMLSpanElement> {
  axis: Axis;
}

export const Space = ({ size, axis, style = {}, ...delegated }: IProps) => {
  const width = axis === 'vertical' ? 1 : size;
  const height = axis === 'horizontal' ? 1 : size;

  return (
    <span
      style={{
        display: 'block',
        width,
        minWidth: width,
        height,
        minHeight: height,
        ...style
      }}
      {...delegated}
    />
  );
};
